import { render, staticRenderFns } from "./DashboardAntiriciclaggio.vue?vue&type=template&id=ac08d1a2&"
import script from "./DashboardAntiriciclaggio.vue?vue&type=script&lang=js&"
export * from "./DashboardAntiriciclaggio.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAntiriciclaggio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports